export interface IWarehouseAdminVogueSupplierData {
    id: number;
    name: string|null;
    vat: string|null;
}

export interface IWarehouseAdminSupplierData {
    id: number;
    name: string|null;
    product_count: number;
    vogue_supplier: IWarehouseAdminVogueSupplierData|null;
}

export default class WarehouseAdminSupplierData {
    id: number;
    name: string|null;
    product_count: number;
    vogue_supplier: IWarehouseAdminVogueSupplierData|null;

    constructor(data: IWarehouseAdminSupplierData) {
        this.id = Number(data.id);
        this.name = data.name ?? null;
        this.product_count = Number(data.product_count ?? 0);
        this.vogue_supplier = data.vogue_supplier ?? null;
    }
}